'use client';

import React from 'react';

import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { CampaignBanner } from '@depop/web-thrift-ui/CampaignBanner';

import { ButtonExperiment } from '@/components/ButtonExperiment';
import { ExtendedLink } from '@/components/ExtendedLink';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { type TransformedWebBannerResponse } from '@/modules/cms/types';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { TrackingType } from '@/modules/home/types.ts';
import {
  createCMSTileHref,
  getBannerImagesForVariant,
} from '@/modules/home/utils';

type Props = {
  webBannerData: TransformedWebBannerResponse[];
  isMobileDevice: boolean;
};

export function MarketingCarouselThriftUi({
  webBannerData,
  isMobileDevice,
}: Props) {
  const { sendActivityTrackerEvent } = useActivityTracker();
  const { web_7707_broaden_appeal_imagery } = useExperiments([
    'web_7707_broaden_appeal_imagery',
  ]);

  function onClick(item: TransformedWebBannerResponse, itemPosition?: number) {
    sendActivityTrackerEvent(ActivityTrackerEventType.MODULE_CLICK_ACTION, {
      moduleName: TrackingType.skinnyBanner,
      itemClicked: item.heading.replace(/ /g, '_'),
      itemPosition,
      schemaVersion: '3.0',
    });
  }

  const items = webBannerData.map((item, index) => {
    const { mobileImageUrl, desktopImageUrl } = getBannerImagesForVariant(
      item,
      web_7707_broaden_appeal_imagery
    );

    return {
      button: (
        <ExtendedLink
          href={createCMSTileHref(
            { link: item.ctaHref, title: item.heading },
            TrackingType.skinnyBanner
          )}
          onClick={() => onClick(item, index)}
        >
          <ButtonExperiment as="span">{item.ctaCopy}</ButtonExperiment>
        </ExtendedLink>
      ),
      headline: item.heading,
      imageAlt: '',
      imageSrc: isMobileDevice ? mobileImageUrl : desktopImageUrl,
      subtitle: documentToPlainTextString(item.bodyJson),
    };
  });

  return (
    <CampaignBanner
      label="Campaign banner"
      slides={items}
      variant="blue"
      autoScroll
    />
  );
}
